var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1038 231L1038 259",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1038.5,
    cy: 226.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1033.99 226.19C1033.99 222.283 1037.29 219.117 1041.36 219.117C1041.94 219.117 1042.51 219.184 1043.06 219.308C1041.74 218.48 1040.19 218 1038.52 218C1033.81 218 1030 221.806 1030 226.5C1030 231.194 1033.81 235 1038.52 235C1040.81 235 1042.89 234.093 1044.43 232.62C1043.49 233.032 1042.45 233.263 1041.36 233.263C1037.29 233.263 1033.99 230.096 1033.99 226.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1047.4 225.6L1047.37 223.146L1045.54 224.719L1043.3 224.056L1044.11 226.337L1042.77 228.381L1045.1 228.218L1046.5 230.144L1047.13 227.763L1049.34 226.909L1047.4 225.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch2);
export default __webpack_public_path__ + "static/media/church_2.4bc53116edbdb1cb6aa4caf4805e9e18.svg";
export { ForwardRef as ReactComponent };